<template>
  <section v-if="!proposals.HideSection" v-cloak>
    <div class="container">
      <div class="row columns">
        <h1 v-html="proposals.Title" />
      </div>
    </div>
    <div class="container">
      <div class="row columns">
        <p v-html="proposals.Body" />
      </div>
    </div>

    <ul class="proposal">
      <li v-for="(policy, index) in proposals.Elements" :key="index" class="proposal-item">
        <div class="container">
          <div class="row column">
            <div class="proposal-title">
              <div class="row align-middel">
                <div class="columns shrink proposal-align-icons medium-1 small-2">
                  <span
                    class="icon icon-large proposal-not-accepted"
                    :class="policy.IconCssClass"
                  />
                </div>
                <div
                  class="columns large-3 medium-5 small-8 proposal-name-div"
                  :class="{
                    'proposal-name-small': policy.StartDateText,
                    'proposal-align': !policy.StartDateText
                  }"
                >
                  <strong
                    class="proposal-name"
                    data-test="proposal-name"
                    v-html="policy.ProductName"
                  />
                  <div
                    v-if="policy.StartDateText"
                    class="proposal-start-date show-for-medium color-gray"
                    data-test="proposal-start-date"
                    v-html="policy.StartDateText"
                  />
                  <p
                    class="show-for-small-only proposal-desc"
                    data-test="proposal-desc"
                    v-html="policy.Description"
                  />
                </div>
                <div class="columns medium-5 show-for-medium proposal-align proposal-text">
                  <p class="proposal-desc" data-test="proposal-desc" v-html="policy.Description" />
                </div>
                <div
                  v-if="policy.DocumentUrl"
                  class="columns proposal-download proposal-align"
                  data-test="proposal-download"
                >
                  <span
                    class="icon icon-download proposal-download-icon"
                    data-test="proposal-download-icon"
                    @click="linkToDocument(policy.DocumentUrl)"
                  />
                  <a
                    class="proposal-link show-for-large"
                    :href="policy.DocumentUrl"
                    target="_blank"
                    data-test="proposal-document-link"
                    v-html="proposals.DocumentLinkLabel"
                  />
                </div>
              </div>
              <div
                v-if="policy.StartDateText"
                class="show-for-small-only small-12 color-gray proposal-date-small"
                data-test="proposal-start-date"
                v-html="policy.StartDateText"
              />
            </div>
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import axios from 'axios';

export default {
  props: {
    apiSource: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      proposals: {}
    };
  },
  mounted() {
    axios
      .get(Utility.constants().API.proposal_awaiting_approval + this.apiSource.toString())
      .then((response) => {
        this.proposals = response.data;
      })
      .catch((err) => {
        Utility.logError(err, this);
      });
  },
  methods: {
    linkToDocument(url) {
      window.open(url);
    }
  }
};
</script>
